import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import Immutable from 'immutable';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { DRIVER_COMMISSION_PATH } from '../../../../config/paths';
import Content from '../../../layout/Content';
import Loader from '../../../common/Loader';
import NoDataResource from '../../../common/resource/NoDataResource';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import {
  clearDriverCommission,
  getDriverCommission,
} from '../../../../actions';
import Table from '../../../common/Table';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_TIME_FORMAT } from '../../../../config/locale';
import DriverCommissionToolbar from './DriverCommissionToolbar';

const DriverCommission = ({
  match: {
    params: { id },
  },
  driverCommision,
  loading,
  breadcrumbs,
  dispatchGetDriverCommission,
  dispatchClearDriverCommission,
}) => {
  useLayoutEffect(() => {
    dispatchGetDriverCommission(id);
    return () => dispatchClearDriverCommission();
  }, []);

  let content = null;
  let toolbar = null;

  if (loading) {
    content = <Loader />;
  } else if (driverCommision.isEmpty()) {
    content = <NoDataResource returnPage={DRIVER_COMMISSION_PATH} />;
  } else {
    toolbar = (
      <DriverCommissionToolbar driverCommissionId={driverCommision.get('id')} />
    );

    content = (
      <>
        <Row>
          <Col>
            <h3>Información Básica</h3>
            <ResourceProperty label="Nombre:">
              {driverCommision.get('name')}
            </ResourceProperty>
            <ResourceProperty label="Descripción:">
              {driverCommision.get('description')}
            </ResourceProperty>
            <ResourceProperty label="Base:">
              {driverCommision.get('baseCommission')}
            </ResourceProperty>
          </Col>
          <Col>
            <h3>Interno</h3>
            <ResourceProperty label="ID:">
              {driverCommision.get('id')}
            </ResourceProperty>
            <ResourceProperty label="Fecha de Creación:">
              {tzNormalizeDate({
                date: driverCommision.get('createDate'),
                format: INT_DATE_TIME_FORMAT,
              })}
            </ResourceProperty>
            <ResourceProperty label="Fecha de Actualización:">
              {tzNormalizeDate({
                date: driverCommision.get('lastUpdate'),
                format: INT_DATE_TIME_FORMAT,
              })}
            </ResourceProperty>
          </Col>
        </Row>
        <h3>Rangos de Condición de Trabajo</h3>
        <Table
          columns={[
            {
              Header: 'Condición de Trabajo / KM',
              accessor: 'commission',
              className: 'text-center',
            },
            {
              Header: 'Inicio (KM)',
              accessor: 'startRange',
              className: 'text-center',
            },
            {
              Header: 'Tipo de Conductor',
              accessor: 'driverType',
              className: 'text-center',
              Cell: (row) => {
                if (!row.value) return 'Todos';
                const { name } = row.value;
                return name;
              },
            },
          ]}
          data={driverCommision.get('driverCommissionRangeList')}
          manual={false}
          filterable={false}
          defaultPageSize={DEFAULT_PAGE_SIZE}
        />
      </>
    );
  }

  return (
    <Content
      title="Comisión de Conductor"
      breadcrumbs={breadcrumbs}
      content={content}
      toolbar={toolbar}
    />
  );
};

DriverCommission.propTypes = {
  match: matchPropTypes.isRequired,
  driverCommision: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetDriverCommission: PropTypes.func.isRequired,
  dispatchClearDriverCommission: PropTypes.func.isRequired,
};

DriverCommission.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ HumanResourcesUnit }) => ({
  breadcrumbs: [
    ...HumanResourcesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Comisiones de Conductores',
      href: DRIVER_COMMISSION_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  driverCommision: HumanResourcesUnit.DriverCommission.getIn([
    'current',
    'content',
  ]),
  loading: !HumanResourcesUnit.DriverCommission.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetDriverCommission: getDriverCommission,
  dispatchClearDriverCommission: clearDriverCommission,
};

export default connect(mapStateToProps, mapDispatchToProps)(DriverCommission);
